import React from "react";
import classNames from "classnames";
import "./index.scss";

import { ACCOUNT_ORDER_STATUS, ORDER_TYPE, PICKUP_STATE } from '../../../utils/enums';

import { DeliveryDraftOrder } from "./DeliveryDraftOrder";
import { PickupOrderDraftItem } from "./PickupDraftOrder";
import { useSortable } from "@dnd-kit/sortable";

const GroupbarOrderItemDraft = ({
  order,
  selected,
  onOrderClick,
  showTime,
  onClickCreate,
  onClickDelete,
  highlight,
  showEditOrder,
  showAssociate,
  onAssociate,
  showExtraButton,
  onChangeState,
  estimatedPriceInfo,
}) => {

  const { attributes, listeners, setNodeRef, transition, transform, isDragging } = useSortable({
    id: order.id
  });

  const style = {
    transition,
    transform: transform ? `translateY(${transform.y}px)` : undefined,
    cursor: isDragging ? 'grabbing' : 'grab',
    zIndex: isDragging ? 999 : 0,
    position: "relative",
  };

  const isDisablePickUp = order.state === PICKUP_STATE.arrived;
  const isDisableDelivery = order.status === ACCOUNT_ORDER_STATUS.finished || order.status === ACCOUNT_ORDER_STATUS.canceled;
  const isDisabled = isDisableDelivery || isDisablePickUp;

  return (
    <div
      {...listeners}
      {...attributes}
      draggable={!isDisabled}
      ref={setNodeRef}
      id={order.id}
      key={order.id}
      className={classNames('groupbarOrderItemDraft', { selected: selected, disabled: isDisabled, highlight })}
      style={style}
    >

      {order.type === ORDER_TYPE.pickUp && (<>
        <PickupOrderDraftItem
          depotId={order.depotId}
          state={order.state}
          estimatedTimeToArrival={order.estimatedTimeToArrival}
          timeOfArrival={order.timeOfArrival}
          extendedState={order.extendedState}
          onClickDelete={onClickDelete}
        />
      </>)}
      {order.type !== ORDER_TYPE.pickUp && (
        <DeliveryDraftOrder
          estimatedPriceInfo={estimatedPriceInfo}
          onChangeState={onChangeState}
          showExtraButton={showExtraButton}
          onAssociate={onAssociate}
          onClickDelete={onClickDelete}
          onClickCreate={onClickCreate}
          order={order}
          onClick={onOrderClick}
          showTime={showTime}
          showEditOrder={showEditOrder}
          showAssociate={showAssociate}
        />
      )}

    </div>
  );
};

export default GroupbarOrderItemDraft;
